import PropTypes from 'prop-types';
export const productScoreWithImagePropTypes = {
  picture: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  score: PropTypes.number
};